import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';

import { UserRole } from 'app/models/auth.models';

@Injectable({
  providedIn: 'root',
})
export class TotalsGuard extends KeycloakAuthGuard {
  constructor(
    protected override readonly router: Router,
    protected readonly keycloak: KeycloakService,
  ) {
    super(router, keycloak);
  }

  async isAccessAllowed(): Promise<boolean | UrlTree> {
    return !this.roles.some((role) => role === UserRole.OFFICER);
  }
}
